import { SwitchProps } from '@mui/material';
import { Controller } from 'react-hook-form';

import { FormElementProps } from '@/components/form/types';
import { Switch } from '@/components/ui/Switch';

import { GenericSkeleton } from '../loaders/GenericSkeleton';

interface FormSwitchProps extends Omit<FormElementProps, 'label'> {
    switchProps?: SwitchProps;
    effectOnChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FormSwitch = ({
    name,
    control,
    switchProps = {},
    controllerProps = {},
    effectOnChange = () => {},
}: FormSwitchProps) => {
    return (
        <Controller
            name={name}
            control={control}
            {...controllerProps}
            render={({ field: { onChange, value } }) => {
                const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                    onChange(event.target.checked);
                    if (typeof effectOnChange === 'function') {
                        effectOnChange(event);
                    }
                };
                if (value === undefined) {
                    return <GenericSkeleton lines={1} />;
                }
                return <Switch onChange={handleOnChange} checked={value} {...switchProps} />;
            }}
        />
    );
};
